import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import { newsEdit, newsUpdate } from '../../../store/actions/websiteActions'
import { Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { referralEdit, referralUpdate } from '../../../store/actions/referralAction';
// import SunEditor from 'suneditor-react';
// import 'suneditor/dist/css/suneditor.min.css';
// import './suneditor.css'


const ReferralEdit = () => {
  const [name, setName] = useState('')
  const [phone, setPhone] = useState('')
  const [email, setEmail] = useState('')
  const [source, setSource] = useState('')

  const [loading, setloading] = useState(false)

  let dispatch = useDispatch()
  let history = useHistory()
  const {id} = useParams();

  useEffect(() => {
    dispatch(referralEdit(id))
  }, [dispatch, id])

  const datanewsUpdate = useSelector(state => state.newsUpdate)
  const { validation } = datanewsUpdate

  const dataLogin = useSelector(state => state.login)
  const { userInfo } = dataLogin
  const updated_by = userInfo.user.id

  const dataReferralEdit = useSelector(state => state.referralEdit)
  const { referral } = dataReferralEdit

  useEffect(() => {
    if (referral) {
      setName(referral.name)
      setEmail(referral.email)
      setPhone(referral.phone)
      setSource(referral.utm_source?.utm_source ?? '')
    }
  }, [referral])

  useEffect(() => {
    if (!userInfo || !userInfo.permission) return;
    if (userInfo.user.roles[0].name === "Super Admin") return;
    if (!userInfo.permission.includes("referrals-edit")) history.push("/403");
  }, [userInfo, history]);

  const handleSubmit = (e) => {
    e.preventDefault();
    referralUpdate(id, {name, phone, email, source}, history)
  }


  return (
    <div className="">
      <div className="page-title">
        <div className="title_left">
          <h3>Edit Referral</h3>
        </div>
      </div>
      <div className="clearfix"></div><br/>
      <div className="row">
        <div className="col-md-6 col-sm-6 col-xs-12">
          <div className="x_panel">
            <div className="x_title">
              <h2>Form Input</h2>
              <div className="clearfix"></div>
            </div>
            
            <div className="x_content overflow-auto">  
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="form-group">
                  <label for="name">Name</label>
                  <input value={name} type="text" className={ validation.length !== 0 && validation['name'] ? 'form-control parsley-error' : 'form-control' }
                  required onChange={(e) => setName(e.target.value)} />
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['name']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <div className="d-flex justify-content-between w-100">
                  <div className="form-group mr-3">
                    <label for="email">Email</label>
                    <input value={email} type="email" className={ validation.length !== 0 && validation['email'] ? 'form-control parsley-error' : 'form-control' }
                    required onChange={(e) => setEmail(e.target.value)} />
                    {
                      validation.length !== 0 
                      ?
                        <ul className="parsley-errors-list filled">
                          <li className="parsley-required">{validation['email']}</li>
                        </ul>
                      :
                        null
                    }
                  </div>

                  <div className="form-group">
                    <label for="phone">Phone Number</label>
                    <input value={phone} type="text" className={ validation.length !== 0 && validation['phone'] ? 'form-control parsley-error' : 'form-control' }
                    required onChange={(e) => setPhone(e.target.value)} />
                    {
                      validation.length !== 0 
                      ?
                        <ul className="parsley-errors-list filled">
                          <li className="parsley-required">{validation['phone']}</li>
                        </ul>
                      :
                        null
                    }
                  </div>
                </div>

                <div className="form-group">
                  <label for="phone">Source</label>
                  <select 
                    className={ validation.length !== 0 && validation['source'] ? 'form-control parsley-error' : 'form-control' }
                    value={source}
                    required onChange={(e) => setSource(e.target.value)}
                  >
                    <option disabled selected value="">Select Source</option>
                    <option value="instagram">Instagram</option>
                    <option value="facebook">Facebook</option>
                    <option value="whatsapp">Whatsapp</option>
                  </select>
                  {
                    validation.length !== 0 
                    ?
                      <ul className="parsley-errors-list filled">
                        <li className="parsley-required">{validation['source']}</li>
                      </ul>
                    :
                      null
                  }
                </div>

                <button type="submit" className="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReferralEdit
